import {Component} from '@angular/core';

@Component({
  selector: 'hangup-ico',
  templateUrl: './hangup-ico.component.html'
})
export class HangupIcoComponent {
}
